module.exports = __webpack_public_path__ + "static/img/partner-logo-17.ae637c5e.png";